import { render, staticRenderFns } from "./ReceiverInfo.vue?vue&type=template&id=0f5eb814&"
import script from "./ReceiverInfo.vue?vue&type=script&lang=ts&"
export * from "./ReceiverInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports